import cx from 'classnames';
import { isFunction } from 'lodash';

/**
 * @param {'progress'|'done'|'dark'|'warning'|'danger-light'|'light'} variant
 * @param {string} [className]
 * @param {string} [tooltip]
 * @param {function(): void} [onClick]
 * @param children
 */
export function StatusBadge({ variant = 'progress', className, tooltip, onClick, children }) {
    return (
        <div
            className={cx('task-badge', `badge--${variant}`, className, {
                'has-click': isFunction(onClick),
            })}
            data-uk-tooltip={tooltip}
            onClick={() => {
                if (isFunction(onClick)) {
                    onClick();
                }
            }}
        >
            {children}
        </div>
    );
}
